import firebaseApp from '../firebase/index';
import CustomError from './errors/CustomError';
import { getCurrentUser } from './user.service';
import { status_response } from './constants';

export { checkProductInFavouriteList, getUserFavouriteInfo, AddOrRemoveToFavouriteList, removeProductInFavouriteList };

const userRef = firebaseApp.firestore().collection('users');

/**
 * Get favourite product info
 */
const getUserFavouriteInfo = async function(user) {
  try {
    if (!user) {
      user = await getCurrentUser();
    }
    const docProfile = await userRef.doc(user.uid).get();
    const { favouriteProInfo } = docProfile.data() || {};
    return {
      status: status_response.success,
      result: {
        data: favouriteProInfo || [],
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Check if a product has in favourite list or not
 * @param {*} productId
 */
const checkProductInFavouriteList = async function(productId, user) {
  try {
    checkProductId(productId);
    if (!user) {
      try {
        user = await getCurrentUser();
      } catch (error) {
        return {
          status: status_response.success,
          result: {
            data: false,
            messageId: 'success'
          }
        };
      }
    }
    let { result, status } = await getUserFavouriteInfo(user);
    if (status === status_response.error) {
      throw new CustomError(result.message, result.messageId);
    }
    const userFavouriteInfo = result.data;
    let checkProductIn = false;
    for (let i in userFavouriteInfo) {
      // eslint-disable-next-line
      if (userFavouriteInfo[i].productId == productId) {
        checkProductIn = true;
        break;
      }
    }
    return {
      status: status_response.success,
      result: {
        data: checkProductIn,
        messageId: 'success'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Add or remove product to user favourite list
 * if already have in favourite list -> remove
 * if not have in favourite list -> add
 * @param {*} shopId
 * @param {*} productId
 */
const AddOrRemoveToFavouriteList = async function(shopId, productId) {
  try {
    checkShopId(shopId);
    checkProductId(productId);
    let { result, status } = await getUserFavouriteInfo();
    if (status === status_response.error) {
      throw new CustomError(result.message, result.messageId);
    }
    let userFavouriteInfo = result.data;
    let checkProductIn = false;
    for (let i in userFavouriteInfo) {
      // eslint-disable-next-line
      if (userFavouriteInfo[i].productId == productId) {
        checkProductIn = true;
        break;
      }
    }
    let check = false;
    if (checkProductIn) {
      userFavouriteInfo = userFavouriteInfo.filter(
        // eslint-disable-next-line
        item => item.productId != productId
      );
    } else {
      const timestamp = new Date().getTime();
      userFavouriteInfo.push({
        shopId,
        productId,
        createdAt: timestamp,
        updatedAt: timestamp
      });
      check = true;
    }
    let { uid: userId } = await getCurrentUser();
    userRef.doc(userId).update({
      favouriteProInfo: userFavouriteInfo
    });
    return {
      status: status_response.success,
      result: {
        data: check,
        messageId: checkProductIn ? 'EF2025_Content' : 'EF2029_Content'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Remove a product from favourite list
 * @param {*} productId
 */
const removeProductInFavouriteList = async function(productId, user) {
  try {
    checkProductId(productId);
    if (!user) {
      user = await getCurrentUser();
    }
    const { result, status } = await getUserFavouriteInfo(user);
    if (status === status_response.error) {
      throw new CustomError(result.message, result.messageId);
    }
    const userFavouriteInfo = result.data;
    const newUserFavouriteInfo = userFavouriteInfo.filter(
      // eslint-disable-next-line
      item => item.productId != productId
    );
    userRef.doc(user.uid).update({
      favouriteProInfo: newUserFavouriteInfo
    });
    return {
      status: status_response.success,
      result: {
        messageId: 'EF2025_Content'
      }
    };
  } catch (error) {
    return {
      status: status_response.error,
      result: {
        message: error.message,
        messageId: error.messageId
      }
    };
  }
};

/**
 * Check valid shopId
 * @param {*} shopId
 */
const checkShopId = function(shopId) {
  if (shopId === null || typeof shopId === 'undefined' || shopId.length === 0) {
    throw new CustomError('ShopId is require!', 'EA2005_Content');
  }
  const isValid = /^(0x){1}[0-9a-fA-F]{40}$/i.test(shopId);
  if (!isValid) {
    throw new CustomError('ShopId is not valid!', 'EA2005_Content');
  }
};

/**
 * Check valid productId
 * @param {*} productId
 */
const checkProductId = function(productId) {
  if (productId === null || typeof productId === 'undefined' || productId.length === 0) {
    throw new CustomError('ProductId is require!', 'EA2005_Content');
  }
  //check product id is number
  if (!/^\d+$/.test(productId)) {
    throw new CustomError('ProductId must be a number!', 'EA2005_Content');
  }
};
